import React from 'react';

const SearchBars = ({ onSearch }) => {
  return (
    <>
      {/* Transfer functionality to menuComp.js */}
    </>
  );
};

export default SearchBars;

